// extracted by mini-css-extract-plugin
export default {"link":"pffAVO","GamingButton":"JICnMZ","gamingButton":"JICnMZ","label":"ZfehX_","left":"sWHzGJ","right":"aJ6ZLO","gradient":"AkkjKt"};